import React from 'react';
import PropTypes from 'prop-types';
import FaArrowRight from 'react-icons/lib/fa/arrow-right';
import cx from 'classnames';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";

export const buttonTypes = {
  next: 'next',
}

const buttons = {
  next: {
    icon: FaArrowRight,
  },
  text: {
    text: true
  }
}

export class Button extends React.Component {
  onClick() {
    if(!this.props.disabled){
      this.props.onClick();
    }
  }

  render() {
    const { type } = this.props;
    const button = buttons[type];
    const classes = cx({
      'button': true,
      'primary': this.props.primary || true,
      'disabled': this.props.disabled,
      [type]: true,
    });

    return (
      <div className={classes} {...doNotUseAccessibleStaticElementInteractions({onClick: this.onClick.bind(this)})} aria-label={type}>
        {button.icon && button.icon({size: '70', className: 'buttonSvg'}) }
        {button.text && (<div className='buttonText'>{this.props.children}</div>)}
      </div>
    );
  }
}

Button.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
}

Button.defaultProps = {
  primary: true,
  disabled: false,
}
